import "./App.css";
import Login from "./Auth/Login";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { useEffect, useState } from "react";
import MainLayout from "./Pages/MainLayout";

import "bootstrap/dist/css/bootstrap.min.css";
import Customers from "./Pages/Customers";
import Sidebar from "./Components/SideNav";
import Home from "./Pages/Home";
import Settings from "./Pages/Settings";
import Users from "./Pages/Users";
import Logs from "./Pages/Logs";
import RemovedCustomers from "./Pages/RemovedCustomers";
import Index from "./landing_pages/Index";
import Schedule from "./Pages/Schedule";
import Cuts from "./Pages/Cuts";
import Booked from "./Pages/Booked";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const userData = sessionStorage.getItem("user-data");
    if (userData) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <Router>
      <Switch>
        {/* Login Route */}
        <Route path="/login">
          {!isAuthenticated ? (
            <Login setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/home" />
          )}
        </Route>

        {/* Protected Routes */}
        <Route path="/">
          {isAuthenticated ? (
            <MainLayout setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Index />
          )}
        </Route>
      </Switch>

      {/* <Switch>
        <Route path="/login">
          {!isAuthenticated ? (
            <Login setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/mainlayout" />
          )}
        </Route>

        <Route path="/mainlayout">
          {isAuthenticated ? (
            <MainLayout setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/sidebar">
          {isAuthenticated ? (
            <Sidebar setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/customers">
          {isAuthenticated ? (
            <Customers setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" /> //
          )}
        </Route>

        <Route path="/home">
          {isAuthenticated ? (
            <Home setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/logs">
          {isAuthenticated ? (
            <Logs setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/settings">
          {isAuthenticated ? (
            <Settings setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/users">
          {isAuthenticated ? (
            <Users setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/schedule">
          {isAuthenticated ? (
            <Schedule setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/removedCustomers">
          {isAuthenticated ? (
            <RemovedCustomers setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/cuts">
          {isAuthenticated ? (
            <Cuts setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/booked">
          {isAuthenticated ? (
            <Booked setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route exact path="/">
          <Index />
        </Route>
      </Switch>   */}

      {/* <Switch>
        <Route path="/login">
          {!isAuthenticated ? (
            <Login setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <MainLayout setIsAuthenticated={setIsAuthenticated} />
          )}
        </Route>
        <Route excat path="/">
          <Index />
        </Route>
      </Switch> */}
    </Router>
  );
}

export default App;
